export const CHARGE_EXPIRES_TYPE_ENUM = {
  DEFAULT: 'DEFAULT',
  FAKE: 'FAKE',
  NONE: 'NONE',
};
